import { render, staticRenderFns } from "./chateau-la-tour-carnet.vue?vue&type=template&id=644d6969&scoped=true"
import script from "./chateau-la-tour-carnet.vue?vue&type=script&lang=js"
export * from "./chateau-la-tour-carnet.vue?vue&type=script&lang=js"
import style0 from "./chateau-la-tour-carnet.vue?vue&type=style&index=0&id=644d6969&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d6969",
  null
  
)

export default component.exports